(function(){
  'use strict';

  var SELECT_SIZE_TEXT = 'Select';
  var BUNDLE_WARNING_TEXT = "There's not enough items in our stock";

  function optName(opt){ return typeof opt === 'string' ? opt : (opt && opt.name ? opt.name : ''); }
  function norm(v){ return String(v || '').toLowerCase().trim(); }
  function esc(v){ return String(v || '').replace(/\\/g,'\\\\').replace(/"/g,'\\"'); }
  function isColor(name){ name = norm(name); return name === 'color' || name === 'colour' || name === 'colors' || name === 'colours'; }
  function isSize(name){ return norm(name) === 'size'; }

  function indexes(product){
    var out = { color:-1, size:-1 };
    if (!product || !product.options) return out;
    for (var i=0;i<product.options.length;i++) {
      var name = optName(product.options[i]);
      if (out.color < 0 && isColor(name)) out.color = i;
      if (out.size < 0 && isSize(name)) out.size = i;
    }
    return out;
  }

  function checked(section, optionName){
    return section.querySelector('input[type="radio"][name="options[' + esc(optionName) + ']"]:checked');
  }

  function setLegend(section, optionName, value){
    var wrap = section.querySelector('[data-select-label="' + esc(optionName) + '"]');
    if (!wrap) return;
    var target = wrap.querySelector('[data-option-value]');
    // A step label ("2. Select size") already says it, so no "Select size" placeholder beside it
    if (value === SELECT_SIZE_TEXT && wrap.hasAttribute('data-step-label')) value = '';
    if (target) target.textContent = value || '';
  }

  function selectedOptions(section, product){
    var selected = [];
    for (var i=0;i<product.options.length;i++) {
      var name = optName(product.options[i]);
      var input = checked(section, name);
      selected[i] = input ? input.value : null;
    }
    return selected;
  }

  function matches(variant, selected){
    for (var i=0;i<selected.length;i++) {
      if (selected[i] !== null && variant.options[i] !== selected[i]) return false;
    }
    return true;
  }

  function findVariant(product, selected){
    for (var i=0;i<product.variants.length;i++) {
      if (matches(product.variants[i], selected)) return product.variants[i];
    }
    return null;
  }

  function mark(input, soldOut){
    var label = input.id ? document.querySelector('label[for="' + esc(input.id) + '"]') : null;
    var holder = input.closest('.swatch__button, .radio__button');
    [input,label,holder].forEach(function(el){
      if (!el) return;
      el.classList.toggle('sold-out', !!soldOut);
      el.classList.toggle('unavailable', !!soldOut);
      el.classList.toggle('spicy-option-sold-out', !!soldOut);
    });
    input.disabled = false;
    if (label) {
      label.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
      label.style.pointerEvents = 'auto';
    }
  }

  function bundleWarnEls(section){
    var cache = section.__spicyWarn;
    if (cache && cache.els.length) {
      var live = cache.els.filter(function(el){ return el.isConnected; });
      if (live.length) { cache.els = live; return live; }
    }
    var now = Date.now();
    if (cache && (now - cache.ts) < 500) return cache.els;
    var nodes = section.querySelectorAll('div, p, span, section');
    var found = [];
    for (var i=0;i<nodes.length;i++) {
      var el = nodes[i];
      var t = el.textContent;
      if (!t || t.indexOf(BUNDLE_WARNING_TEXT) === -1) continue;
      var childHasText = false;
      for (var c=0;c<el.children.length;c++) {
        var ct = el.children[c].textContent;
        if (ct && ct.indexOf(BUNDLE_WARNING_TEXT) !== -1) { childHasText = true; break; }
      }
      if (!childHasText) found.push(el);
    }
    section.__spicyWarn = { els: found, ts: now };
    return found;
  }

  function setBundleWarningSuppressed(section, suppress){
    bundleWarnEls(section).forEach(function(el){
      if (suppress) {
        if (!el.dataset.spicyOriginalDisplay) el.dataset.spicyOriginalDisplay = el.style.display || '__empty__';
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      } else if (el.dataset.spicyOriginalDisplay) {
        el.style.display = el.dataset.spicyOriginalDisplay === '__empty__' ? '' : el.dataset.spicyOriginalDisplay;
        el.removeAttribute('aria-hidden');
        delete el.dataset.spicyOriginalDisplay;
      }
    });
  }

  function buttonState(section, variant, message, needsSize){
    var form = section.querySelector('form[data-product-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addTxt = form.querySelector('[data-add-to-cart-text]');
    var payBtns = form.querySelectorAll('.shopify-payment-button button');
    var inactive = !variant || !variant.available;

    if (idInput) idInput.value = variant && variant.available ? variant.id : '';
    if (addTxt) addTxt.textContent = message || (window.theme && window.theme.strings ? window.theme.strings.addToCart : 'Add to cart');
    if (addBtn) {
      addBtn.disabled = inactive;
      if (inactive) addBtn.setAttribute('disabled','disabled'); else addBtn.removeAttribute('disabled');
      addBtn.setAttribute('aria-label', addTxt ? addTxt.textContent : (message || 'Add to cart'));
      // Spicy CRO styles this (full contrast) and turns a tap into a jump to the sizes
      addBtn.classList.toggle('sw-needs-size', !!needsSize);
    }
    for (var i=0;i<payBtns.length;i++) {
      payBtns[i].disabled = inactive;
      if (inactive) payBtns[i].setAttribute('disabled','disabled'); else payBtns[i].removeAttribute('disabled');
    }
  }

  function colorAvailability(section, product, ix){
    if (ix.color < 0) return;
    var colorName = optName(product.options[ix.color]);
    var available = {};
    product.variants.forEach(function(v){
      var color = v.options[ix.color];
      if (!(color in available)) available[color] = false;
      if (v.available) available[color] = true;
    });
    var inputs = section.querySelectorAll('input[type="radio"][name="options[' + esc(colorName) + ']"]');
    for (var i=0;i<inputs.length;i++) mark(inputs[i], available[inputs[i].value] !== true);
  }

  function sizeAvailability(section, product, ix){
    if (ix.size < 0) return;
    var sizeName = optName(product.options[ix.size]);
    var colorName = ix.color >= 0 ? optName(product.options[ix.color]) : null;
    var colorInput = colorName ? checked(section, colorName) : null;
    var inputs = section.querySelectorAll('input[type="radio"][name="options[' + esc(sizeName) + ']"]');
    for (var i=0;i<inputs.length;i++) {
      var selected = [];
      selected[ix.size] = inputs[i].value;
      if (ix.color >= 0 && colorInput) selected[ix.color] = colorInput.value;
      var v = findVariant(product, selected);
      mark(inputs[i], !v || !v.available);
    }
  }

  function refresh(section, product, ix){
    colorAvailability(section, product, ix);
    sizeAvailability(section, product, ix);
    var sizeName = ix.size >= 0 ? optName(product.options[ix.size]) : null;
    var sizeInput = sizeName ? checked(section, sizeName) : null;
    var noSizeSelected = ix.size >= 0 && !sizeInput;
    if (sizeName) setLegend(section, sizeName, sizeInput ? sizeInput.value : SELECT_SIZE_TEXT);

    setBundleWarningSuppressed(section, noSizeSelected);
    if (noSizeSelected) {
      setTimeout(function(){ setBundleWarningSuppressed(section, true); }, 200);
    }

    var variant = findVariant(product, selectedOptions(section, product));
    // Button wording is editable in Header group > Spicy CRO
    if (noSizeSelected) return buttonState(section, null, window.swSizeButtonText || SELECT_SIZE_TEXT, true);
    if (!variant) return buttonState(section, null, window.theme && window.theme.strings ? window.theme.strings.unavailable : 'Unavailable');
    if (!variant.available) return buttonState(section, variant, window.theme && window.theme.strings ? window.theme.strings.soldOut : 'Sold out');
    buttonState(section, variant, null);
  }

  function clearSize(section, product, ix){
    if (ix.size < 0) return;
    var sizeName = optName(product.options[ix.size]);
    var inputs = section.querySelectorAll('input[type="radio"][name="options[' + esc(sizeName) + ']"]');
    for (var i=0;i<inputs.length;i++) {
      inputs[i].checked = false;
      inputs[i].removeAttribute('checked');
    }
    setLegend(section, sizeName, SELECT_SIZE_TEXT);
    setBundleWarningSuppressed(section, true);
  }

  function initSection(section){
    if (!section || section.dataset.spicyVariantSelectionOverride === 'true') return;
    var json = section.querySelector('[data-product-json]');
    if (!json || !json.textContent.trim()) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch(e) { return; }
    if (!product || !product.variants || !product.options) return;
    var ix = indexes(product);
    if (ix.color < 0 && ix.size < 0) return;
    section.dataset.spicyVariantSelectionOverride = 'true';
    clearSize(section, product, ix);
    refresh(section, product, ix);
    setTimeout(function(){ clearSize(section, product, ix); refresh(section, product, ix); }, 400);

    var pending = null;
    function scheduleRefresh(){
      if (pending) clearTimeout(pending);
      pending = setTimeout(function(){ refresh(section, product, ix); pending = null; }, 120);
    }

    section.addEventListener('change', function(e){
      if (!e.target || !e.target.matches('input[type="radio"][name^="options["]')) return;
      scheduleRefresh();
    }, true);
    section.addEventListener('theme:variant:change', function(){
      scheduleRefresh();
    });
  }

  function init(){
    document.querySelectorAll('[data-section-type="product"]').forEach(initSection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function(e){ initSection(e.target); });
})();
